"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AnimationObject_1 = require("../AnimationObject");
var AnimationTransform_1 = require("../helpers/AnimationTransform");
var Effect_1 = require("../effects/Effect");
var AnimationLayerType;
(function (AnimationLayerType) {
    AnimationLayerType[AnimationLayerType["PreComp"] = 0] = "PreComp";
    AnimationLayerType[AnimationLayerType["Solid"] = 1] = "Solid";
    AnimationLayerType[AnimationLayerType["Image"] = 2] = "Image";
    AnimationLayerType[AnimationLayerType["Null"] = 3] = "Null";
    AnimationLayerType[AnimationLayerType["Shape"] = 4] = "Shape";
    AnimationLayerType[AnimationLayerType["Text"] = 5] = "Text";
    AnimationLayerType[AnimationLayerType["Video"] = 9] = "Video";
})(AnimationLayerType = exports.AnimationLayerType || (exports.AnimationLayerType = {}));
var AnimationLayer = (function (_super) {
    tslib_1.__extends(AnimationLayer, _super);
    function AnimationLayer(rawData, version) {
        var _this = _super.call(this, rawData, version) || this;
        _this.transform = new AnimationTransform_1.AnimationTransform(_this._rawData.ks, version);
        if (_this._rawData.ef === undefined) {
            _this._rawData.ef = [];
        }
        _this.effects = _this._rawData.ef.map(function (ef) { return new Effect_1.Effect(ef, version); });
        return _this;
    }
    Object.defineProperty(AnimationLayer.prototype, "index", {
        get: function () {
            return this._rawData.ind;
        },
        set: function (index) {
            this._rawData.ind = index;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationLayer.prototype, "type", {
        get: function () {
            return this._rawData.ty;
        },
        set: function (type) {
            this._rawData.ty = type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationLayer.prototype, "autoOrient", {
        get: function () {
            if (this._rawData.ao) {
                return this._rawData.ao === 1;
            }
            return undefined;
        },
        set: function (autoOrient) {
            this._rawData.ao = (autoOrient ? 1 : 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationLayer.prototype, "dddRender", {
        get: function () {
            if (this._rawData.ddd) {
                return this._rawData.ddd === 1;
            }
            return undefined;
        },
        set: function (dddRender) {
            this._rawData.ddd = (dddRender ? 1 : 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationLayer.prototype, "hidden", {
        get: function () {
            return this._rawData.hd;
        },
        set: function (hidden) {
            this._rawData.hd = hidden;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationLayer.prototype, "name", {
        get: function () {
            return this._rawData.nm;
        },
        set: function (name) {
            this._rawData.nm = name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationLayer.prototype, "parent", {
        get: function () {
            return this._rawData.parent;
        },
        set: function (parent) {
            this._rawData.parent = parent;
        },
        enumerable: true,
        configurable: true
    });
    return AnimationLayer;
}(AnimationObject_1.AnimationObject));
exports.AnimationLayer = AnimationLayer;
//# sourceMappingURL=AnimationLayer.js.map